import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';

@Injectable()
export class AppGlobalErrorhandler implements ErrorHandler {
  constructor(private http: HttpClient) {}

  handleError(error: any): void {
    // console.error(error);
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Message: ${error.message}`;
    }
    const errorData = errorMessage.split('at ');
    const newErrorMessage = errorData[0] + 'line:' + errorData[1];
    if (errorData[1] == undefined) {
      return;
    }
    // let errorLog = JSON.parse(localStorage.getItem('errorLog'));
    // if (errorLog == null) {
    //   errorLog = [];
    //   errorLog.push({ date: new Date(), msg: newErrorMessage });
    // } else {
    //   if (errorLog.length < 20) {
    //     errorLog.push({ date: new Date(), msg: newErrorMessage });
    //   } else {
    //     errorLog.shift();
    //     errorLog.push({ date: new Date(), msg: newErrorMessage });
    //   }
    // }
    // localStorage.setItem('errorLog', JSON.stringify(errorLog));
    this.http.post('error/report', { date: new Date(), message: newErrorMessage }).subscribe(
      (res) => {
        console.log(res);
      },
      (res) => {
        console.log(res);
      },
      () => {},
    );
    return;
  }
}
